<template>
    <div id="add-phones">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label style="font-weight: bold;" for="">{{$t('message.addPhones')}}</label>
                    <select class="form-control mb-3" v-model="phoneType">
                        <option value="businessMobile">
                            {{$t('message.businessMobile')}}
                        </option>
                        <option value="business">{{$t('message.business')}}
                        </option>
                    </select>
                    <input v-model="phoneNumber" type="text"
                           class="form-control mb-3"
                           :placeholder="$t('message.number')">
                    <button v-if="!oldNumber" @click="addPhone"
                            class="btn btn-success">
                        {{$t('message.add')}} +
                    </button>
                    <button class="btn btn-success" v-if="oldNumber"
                            @click="editPhone">{{$t('message.update')}}
                    </button>
                </div>
            </div>
            <div class="col-md-6">
                <div>
                    <label>{{$t('message.phones')}}</label>
                    <div>
                        <div v-if="user.phones.length === 0">
                            <div
                                    class="alert alert-info fade show">
                                {{$t('message.noPhones')}}
                            </div>
                        </div>
                        <div v-for="(phone, index) in user.phones" :key="index"
                             class="alert alert-success fade show">
                            <button @click="removePhone(phone.number)"
                                    class="close"><i
                                    data-v-1748338c=""
                                    class="fa fa-trash font-14"></i>
                            </button>
                            <button style="margin-right: 1%" @click="editPhoneSet(phone)"
                                    data-original-title="Edit"
                                    class="close"><i
                                    data-v-1748338c=""
                                    class="fa fa-pencil font-14"></i></button>
                            <strong>{{$t('message.' + phone.type)}}:</strong>
                            {{phone.number}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import OkModal from '../../modals/OkModal'

  export default {
    name: 'AddEditPhones',
    data () {
      return {
        phoneType: '',
        phoneNumber: '',
        oldNumber: null
      }
    },
    props: ['user'],
    methods: {
      editPhoneSet (phone) {
        this.phoneNumber = phone.number
        this.phoneType = phone.type
        this.oldNumber = phone.number
      },
      editPhone () {
        this.user.phones = this.user.phones.map(obj => {
          if (obj.number === this.oldNumber) {
            obj.number = this.phoneNumber
            obj.type = this.phoneType
          }
          return obj
        })

        this.oldNumber = null
        this.phoneNumber = ''
        this.phoneType = ''
      },
      removePhone (number) {
        this.user.phones = this.user.phones.filter(obj => {
          return obj.number !== number
        })
      },
      addPhone () {
        let msg = ''

        if (this.phoneType === '') {
          msg = this.$t('message.providePhoneType')
        }

        if (this.phoneNumber === '') {
          msg = this.$t('message.providePhoneNumber')
        }

        if (this.user && this.phoneNumber && this.phoneType) {
          this.user.phones.push({type: this.phoneType, number: this.phoneNumber})
          this.phoneType = ''
          this.phoneNumber = ''
        } else {
          this.$modal.show(OkModal, {
              text: msg,
              modalClass: this.modalClasses.okErrorClass
            },
            {
              width: this.modalWidth(),
              height: 'auto'
            })
        }
      }
    }
  }
</script>

<style scoped>
label{
        font-weight: bold;
    }
</style>